/**
 * @generated SignedSource<<fd184a0ea6af6ccd3fd9d1ea372f4219>>
 * @relayHash d28bd593a28a3d416f488b86a8cfd521
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d28bd593a28a3d416f488b86a8cfd521

import type { ConcreteRequest } from 'relay-runtime';
export type CreateLabelInput = {
  clientMutationId?: string | null | undefined;
  color: string;
  description?: string | null | undefined;
  name: string;
  repositoryId: string;
};
export type createRepositoryLabelMutation$variables = {
  input: CreateLabelInput;
};
export type createRepositoryLabelMutation$data = {
  readonly createLabel: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly label: {
      readonly color: string;
      readonly description: string | null | undefined;
      readonly id: string;
      readonly name: string;
      readonly nameHTML: string;
    } | null | undefined;
  } | null | undefined;
};
export type createRepositoryLabelMutation = {
  response: createRepositoryLabelMutation$data;
  variables: createRepositoryLabelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "Label",
  "kind": "LinkedField",
  "name": "label",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nameHTML",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "createRepositoryLabelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateLabelPayload",
        "kind": "LinkedField",
        "name": "createLabel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "createRepositoryLabelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateLabelPayload",
        "kind": "LinkedField",
        "name": "createLabel",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "d28bd593a28a3d416f488b86a8cfd521",
    "metadata": {},
    "name": "createRepositoryLabelMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a9314294ea224f78cf3434f0739960b3";

export default node;
